export default "__VITE_ASSET__8iK79Fwf__"